import React from "react";
import logger from "logger";

export const StringArray = ({ label, array, valueParser = (key) => key }) => {
  if (!array) {
    return null;
  }
  return (
    <div>
      <div className="infokey">{label}</div>
      {array &&
        array.map((key, index) => {
          return (
            <div key={index} className="infovalue" style={{ fontSize: "15px" }}>
              {valueParser(key)}
            </div>
          );
        })}
    </div>
  );
};
